import Header from './components/header'
import Contact from './components/contact'
import Footer from "./components/footer"


function Home() {
    return (
        <>
            <Header
            ></Header>
            <Contact></Contact>
            <Footer></Footer>
        </>
    )
}

export default Home;

